import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Login from './views/Login';
import Landing from './views/Landing';
import ChefView from './views/chef/ChefView';
import GMView from './views/gm/GMView';
import BartenderView from './views/bartender/BartenderView';
import SuppliesView from './views/supplies/SuppliesView';
import AdminView from './views/admin/AdminView';
import PropertyView from './views/property/PropertyView';
import Shell from './components/Shell';

// Returns true when running on a restaurant subdomain (e.g. napua.paradiseops.ai)
function isPortalSubdomain() {
  const parts = window.location.hostname.split('.');
  return parts.length >= 3 && parts[0] !== 'www' && parts[0] !== 'api';
}

function RoleRouter() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;

  const roleMap = {
    chef: '/chef',
    gm: '/gm',
    bartender: '/bartender',
    supplies: '/supplies',
    restaurant_admin: '/admin',
    super_admin: '/admin',
    staff: '/chef',
  };

  return <Navigate to={roleMap[user.role] || '/chef'} replace />;
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  // Root domain → brochure only
  if (!isPortalSubdomain()) {
    return <Landing />;
  }

  // Subdomain (e.g. napua.paradiseops.ai) → full portal
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RoleRouter />} />
          <Route path="/chef/*" element={<ProtectedRoute><Shell><ChefView /></Shell></ProtectedRoute>} />
          <Route path="/gm/*" element={<ProtectedRoute><Shell><GMView /></Shell></ProtectedRoute>} />
          <Route path="/bartender/*" element={<ProtectedRoute><Shell><BartenderView /></Shell></ProtectedRoute>} />
          <Route path="/supplies/*" element={<ProtectedRoute><Shell><SuppliesView /></Shell></ProtectedRoute>} />
          <Route path="/admin/*" element={<ProtectedRoute><Shell><AdminView /></Shell></ProtectedRoute>} />
          <Route path="/property/*" element={<ProtectedRoute><Shell><PropertyView /></Shell></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
